<template>
  <div class="lang-select">
    <div class="main-container">
      <div v-for="l in langs" :key="l.code" :style="{ backgroundImage: 'url(' + l.flag + ')' }" class="flag" @click="setActiveLang(l.code)">
        <span class="label">{{ l.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import format from '@/utils/format.js'

/* eslint-disable arena/no-hardcode-param-types */

export default {
  name: 'LangSelect',
  data () {
    return {
    }
  },
  filters: {
    formatTitle: format.formatTitle,
    firstCharUpper: format.firstCharUpper
  },
  computed: {
    ...mapGetters(['langs'])
  },
  methods: {
    ...mapMutations(['setActiveLang'])
  }
}
/* eslint-enable arena/no-hardcode-param-types */

</script>
<style>
div.lang-select {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 101;
}
div.lang-select > div.main-container {
  padding: 0 30px;
  position: absolute;
  width: calc(100% - 60px);
  text-align: center;
}
div.lang-select > div.main-container > div.flag {
  width: 48%;
  padding-top: 32%;
  margin: 65px 0;
  position: relative;
  left: 26%;
  background-size: cover;
  background-position: center;
  box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
  cursor: pointer;
}
div.lang-select > div.main-container > div.flag > span.label {
  position: absolute;
  bottom: -40px;
  width: 100%;
  left: 0;
  font-size: 30px;
}
</style>
